module.exports = __webpack_public_path__ + "static/media/image-1.7da1df60.avif";